import { useSyncExternalStore } from 'react';

// EWM-760 — touch capability is static per session (doesn't change without a
// reload), so subscribe is a no-op; useSyncExternalStore just swaps the SSR
// default (false) for the real client read after hydration, no setState-in-effect.
const subscribe = () => () => {};
const getSnapshot = () => 'ontouchstart' in window || navigator.maxTouchPoints > 0;
const getServerSnapshot = () => false;

const useTouchDevice = () => {
  const isTouchDevice = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);

  return { isTouchDevice };
};

export default useTouchDevice;
